import React, { useCallback } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import { Icon } from 'js/components';

import { Card, CardBody, CardTitle } from 'reactstrap';

import styles from './ManagedProductsDashboard.module.scss';

// const MAX_LIST_ITEMS = 5;

const ManagedProduct = ({ managedProduct, onArchive, onRestore }) => {
  // const { workspaceId } = useParams();
  // const collator = useStandardCollator();

  // const userGroups = useMemo(
  //   () => managedProduct?.stats?.user_groups ?? [],
  //   [managedProduct?.stats?.user_groups]
  // );

  // const capabilities = useMemo(() => {
  //   const capabilities = new Map();
  //   userGroups.forEach((userGroup) => {
  //     userGroup.capability_sets.forEach((capabilitySet) => {
  //       capabilitySet.capabilities.forEach((capability) => {
  //         capabilities.set(capability.id, capability);
  //       });
  //     });
  //   });

  //   return Array.from(capabilities.values()).sort(
  //     (a, b) => collator.compare(a.name, b.name) || collator.compare(a.id, b.id)
  //   );
  // }, [managedProduct.stats, collator]);

  const isArchived = managedProduct.archived_at !== null;

  const handleArchive = useCallback(() => {
    onArchive(managedProduct);
  }, [onArchive, managedProduct]);

  const handleRestore = useCallback(() => {
    onRestore(managedProduct);
  }, [onRestore, managedProduct]);

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <CardTitle tag="h5">
              <Link
                to={`/w/${managedProduct.workspace_id}/pm/products/${managedProduct.id}`}
                className="text-decoration-none"
              >
                {managedProduct.name}
              </Link>
            </CardTitle>
            <div
              className={cx(
                styles['managed-product-description'],
                'line-clamp-3'
              )}
            >
              {managedProduct.description}
            </div>
            {/* <div className={styles['managed-product-user-groups']}>
              <LimitedList
                items={userGroups}
                maxItems={MAX_LIST_ITEMS}
                itemKey={(ug) => ug.id}
                renderItem={(ug) => ug.name}
              />
            </div>
            <div className={styles['managed-product-capabilities']}>
              <LimitedList
                items={capabilities}
                maxItems={MAX_LIST_ITEMS}
                itemKey={(capability) => capability.id}
                renderItem={(capability) => capability.name}
              />
            </div> */}
          </div>
          <div className="actions">
            {isArchived ? (
              <Button
                color="secondary"
                size="sm"
                className="btn-icon"
                onClick={handleRestore}
              >
                <Icon icon="box-open" />
              </Button>
            ) : (
              <Button
                color="secondary"
                size="sm"
                className="btn-icon"
                onClick={handleArchive}
              >
                <Icon icon="archive" className="btn-icon" />
              </Button>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default ManagedProduct;
